import { RefObject } from "react"
import { cn } from "@ui/utils"

import { EditorFormatButtons } from "@/components/lexical/editor-format-buttons"
import { EditorRefHandle } from "@/components/lexical/editors/email"

export function FloatingFormatBar({
  editorRef,
  visible,
  enableChecklist = false,
}: {
  editorRef: RefObject<Pick<EditorRefHandle, "getEditor"> | null>
  visible: boolean
  enableChecklist?: boolean
}) {
  return (
    <div
      className={cn(
        "bg-background absolute bottom-full left-1/2 z-10 mb-1.5 flex max-w-[calc(100vw-2rem)] -translate-x-1/2 items-center gap-0.5 rounded-lg border p-0.5 shadow-sm transition-all duration-200",
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-2 opacity-0"
      )}
      onMouseDown={(e) => e.preventDefault()}
      {...(!visible && { inert: true })}
    >
      <EditorFormatButtons editorRef={editorRef} enableTable enableChecklist={enableChecklist} />
    </div>
  )
}
